// exclude-from-index
import React from 'react';

import CardGrid from '../../CardGrid/CardGrid';
import Grid from '../../Utility/Grid';
import VerticalSpacing from '../../Utility/VerticalSpacing';
import Text from '../../BuildingBlocks/Text';

import Card from '../../Card/Card';

function Wrapper(props) {
  const { title, cardData, link } = props;

  return (
    <VerticalSpacing>
      <Grid.Container>
        <Grid.Row>
          <Grid.Col>
            <Text.HeadingSecond tagName="h2">{title}</Text.HeadingSecond>
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>
      <CardGrid>
        {cardData.map(card => (
          <Card key={card.id} {...card} />
        ))}
      </CardGrid>
      <Grid.Container>
        <Grid.Row>
          <Grid.Col>{link}</Grid.Col>
        </Grid.Row>
      </Grid.Container>
    </VerticalSpacing>
  );
}

export default Wrapper;
